import Ajax from "base/Ajax";
import Toolbar from "toolbar/Toolbar";
import ToolbarItemText from "toolbar/ToolbarItemText";

export default class LastUpdatedHelper {
    static display_time(time) {
        $(".js-last-updated-display").text(time ? time.formatted : "N/A")
    }

    static init() {
        this.display_time(window.CONFIG.billing.lastUpdated);

        setInterval(() => LastUpdatedHelper.update_time(), 30 * 1000 /* 30 Seconds */);
    }

    static async update_time() {
        try {
            let time = await Ajax.get("base", "config/last-updated");

            this.display_time(time);
        } catch (e) {
            console.warn("Couldn't update last-updated time", e);
        }
    }
}
